import { useQuery } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert } from '../../../utils/alert'

type Itens = {
  cod: number
  cod_conta: number
  cod_cliente: null
  cod_categoria_produto: number
  cod_fabricante: number
  nome: string
  descricao: null
  create_time: string
  update_time: null
  delete_time: null
  cod_formulacao: null
  adjuvante: number
  cod_tipo_adjuvante: null
  observacao: null
  cod_medida_aplicacao: number
  nome_medida_aplicacao: string
  cod_medida_composicao: number
  create_user: string
  update_user: null
  delete_user: null
  cod_classe_agronomica: number
  cod_replica: null
  cod_variedade_hibrido: null
  cod_fertilizante: null
  cod_tecnologia: null
  acao_ph_calda: string
  fabricante_nome: string
  categoria_produto_nome: string
  classe_agronomica_nome: string
  fertilizante: any[]
  composicao: Composicao[]
  propriedades_adjuvante: PropriedadesAdjuvante[]
  doses: Doses[]
}

type Composicao = {
  cod: number
  cod_produto: number
  cod_ativo: number
  concentracao: string
  create_time: string
  update_time: null
  delete_time: null
  create_user: string
  update_user: null
  delete_user: null
  cod_replica: null
  produto_nome: string
  cod_tipo_medida: number
  nome_tipo_medida: string
  ativo_nome: string
  ativo: Ativo[]
}

type PropriedadesAdjuvante = {
  cod: number
  cod_adjuvante: number
  cod_propriedade_adjuvante: number
  create_time: string
  update_time: null
  delete_time: null
  tipo_propriedade_adjuvante: number
  create_user: string
  update_user: null
  adjuvante_nome: string
  propriedade_adjuvante_nome: string
}

type Ativo = {
  cod: number
  nome: string
  cod_categoria_produto: null
  cod_grupo_quimico: number
  cod_classe_quimica: number
  cod_grupo: number
  cod_modo_acao: number
  cod_local_acao: number
  cod_mecanismo_acao: number
  create_time: string
  update_time: null
  delete_time: null
  cod_classe_agronomica: number
  create_user: string
  update_user: null
  delete_user: null
  classe_agronomica_nome: string
  grupo_quimico_nome: string
  grupo_nome: string
  classe_quimica_nome: string
  modo_acao_nome: string
  local_acao_nome: string
  mecanismo_acao_nome: string
  local_mecanismo_acao: string
}

type Doses = {
  cod: number
  cod_cultura: number
  cod_adjuvante: number
  dose: string
  min_dose: null
  max_dose: null
  create_time: string
  update_time: null
  delete_time: null
  create_user: string
  update_user: null
  cod_replica: null
  aduvante_nome: string
  cultura_nome: string
}

interface Adjuvantes {
  itens: Itens[]
  total: number
}

export const useGetAdjuvantes = (pagination = 15, page = 1, nome?: string) => {
  const queryKey: any = [`/recomendacao/adjuvante`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Adjuvantes, Error>(
    queryKey,
    async () => {
      return api
        .get(
          `/recomendacao/adjuvante?codConta=${
            localConfig()?.conta
          }&pagination=${pagination}&page=${page}&embed=composicao,adjuvante&nome=${nome}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de adjuvantes!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_adjuvantes: data,
    carregando_adjuvantes: isFetching,
    refetch_data_adjuvantes: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetAdjuvantesEditar = (cod: number) => {
  const queryKey: any = [`/recomendacao/adjuvante_${cod}`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Adjuvantes, Error>(
    queryKey,
    async () => {
      return api
        .get(
          `/recomendacao/adjuvante?codConta=${
            localConfig()?.conta
          }&cod=${cod}&embed=composicao,adjuvante`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de adjuvantes!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_adjuvantes_editar: data,
    carregando_adjuvantes_editar: isFetching,
    refetch_data_adjuvantes_editar: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}